import * as DepartmentPageActionTypes from '../actionTypes/DepartmentPageActionTypes';

export const onPageReady = (pageName, pageType) => ({ // eslint-disable-line
    type: DepartmentPageActionTypes.DEPARTMENT_PAGE_LOAD_READY,
    payload: { pageName, pageType },
});
